import { NumberField, Table } from '@approvalmax/ui/src/components';
import { constants } from 'modules/common';
import { WarningLevel } from 'modules/request';
import { memo } from 'react';
import { DifferenceWarning } from 'shared/components';

import { useOcrLinesItems } from '../../hooks';
import { messages } from './AmountCell.messages';
import { AmountCellProps } from './AmountCell.types';

export const AmountCell = memo<AmountCellProps>((props) => {
    const { cellProps, name, currency, ...otherProps } = props;

    const { index, amount } = cellProps.item;

    const sortedOcrLineItems = useOcrLinesItems();

    const amountOcr = sortedOcrLineItems?.[index]?.amount;
    const amountOcrRecognized = typeof amountOcr === 'number' ? amountOcr : undefined;

    const showWarning = amountOcrRecognized && amount ? amount !== amountOcrRecognized : false;

    return (
        <Table.FormCell
            {...cellProps}
            name={`lines.${index}.${name}`}
            warningLevel={showWarning ? WarningLevel.Yellow : WarningLevel.None}
            warningMessage={
                showWarning ? (
                    <DifferenceWarning
                        value1={amount}
                        value2={amountOcrRecognized}
                        currency={currency}
                        label1={messages.differenceWarningBill}
                        label2={messages.differenceWarningFile}
                        description={messages.warning}
                    />
                ) : undefined
            }
        >
            {(fieldProps) => (
                <NumberField
                    {...fieldProps}
                    bordered={false}
                    size='small'
                    precision={8}
                    allowFloat
                    textAlign='right'
                    min={constants.qBooksConstants.MIN_AMOUNT}
                    max={constants.qBooksConstants.MAX_AMOUNT}
                    {...otherProps}
                />
            )}
        </Table.FormCell>
    );
});

AmountCell.displayName = 'AmountCell';
